/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Your_TitleInputs */



/**
* | output |
* | --- |
* | "Your Responsibility:" |
*
* @param {Guardrails_Section_3_Your_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_your_title = /** @type {((inputs?: Guardrails_Section_3_Your_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Your_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Verantwortung:")
	return /** @type {LocalizedString} */ ("Your Responsibility:")
});